'use strict';

module.exports = function () {
    $('body').on('mouseenter focusin click', '.info-icon, .tooltip', function () {
        $(this).find('.tooltip').removeClass('d-none');
    });

    $('body').on('mouseleave blur', '.info-icon, .tooltip', function () {
        let $this = $(this);
        if ($this.hasClass('info-icon')) {
            $this.find('.tooltip').addClass('d-none');
        } else {
            $this.addClass('d-none');
        }
    });

    $('body').on('keydown', function(event) {
        if (event.key === 'Escape') {
            $('.tooltip').addClass('d-none');
        }
    });
};
